import { useState, useEffect, useTransition } from 'react';
import axios from 'axios';
import Main from '../../../../component/Main';
import { useLocation } from 'react-router-dom';
import SelectBox from './SelectBox';
import PtmiDataGrid from './PtmiDataGrid';
import LogDataGrid from './LogDataGrid';
import JrNaeYeokDetail from './JrNaeYeokDetail';
import WholeLoading from '../../../../component/common/loading/WholeLoading';
import { useExcelDownloadHook } from '../../../common/excel/useExcelDownloadHook.js';
import ExcelDownloadReason_layer from '../../../../component/common/modal/ExcelDownloadReason_layer';
import { usePatientOnly } from '../../../../hooks/useBreakPoint.js';

import '../../../../css/patient-detail.css';
import * as Theme from '../../../../images/icons/icons_theme';

const BdJrNaeyeokDetailListANew = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: localStorage.getItem('userAuth') === 'J003' ? localStorage.getItem('useremcd') : '',
        searchGrdc: localStorage.getItem('userAuth') === 'J003' ? localStorage.getItem('emoggrdc2') : '',
        searchLoca: localStorage.getItem('userAuth') === 'J003' ? localStorage.getItem('emogloca') : '',
        searchGubun: '',
        searchGubunS: '',
        searchDateCls: '01',
        searchIdno: '',
    });

    const [isWholeLoading, setIsWholeLoading] = useState(false);
    const [, startTransition] = useTransition();
    const [isDetailToggle, setIsDetailToggle] = useState(false);
    const [isListToggle, setIsListToggle] = useState(true);
    const [desc, setDesc] = useState('');

    const toggleIcon = isDetailToggle ? <Theme.DetailClose className='st_soft' /> : <Theme.DetailOpen className='st_soft' />;
    const hoverToggleIcon = isDetailToggle ? <Theme.DetailClose className='st_bright' /> : <Theme.DetailOpen className='st_bright' />;
    const listToggleIcon = isListToggle ? <Theme.DetailOpen className='tr_soft' /> : <Theme.DetailClose className='tr_soft' />;
    const hoverListToggleIcon = isListToggle ? <Theme.DetailOpen className='tr_bright' /> : <Theme.DetailClose className='tr_bright' />;

    const [selectedPatient, setSelectedPatient] = useState({
        searchEmog: '',
        searchIdno: '',
        searchIndt: '',
        searchIntm: ''
    });

    const [data, setData] = useState([]);
    const [data2, setData2] = useState([]);

    // 선택된 환자 상세정보
    const bdjrnaeyeoDetailData = async () => {
        try {
            const response = await axios.get('/ptmiapi/jinryo/bdjrnaeyeoDetail_popup.do',
                { params: selectedPatient }
            );
            setIsWholeLoading(false);
            startTransition(() => {
                setData(response.data);
            });
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
        }
    };

    // 선택된 환자 로그 정보
    const logData = async () => {
        try {
            const response = await axios.get('/ptmiapi/jinryo/bdjsnaeyeok.do',
                { params: selectedPatient }
            );
            startTransition(() => {
                setData2(response.data);
            });
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
        }
    };

    useEffect(() => {
        // 환자 선택 전(초기 마운트)에는 빈 파라미터로 상세/로그를 조회하지 않음
        if (!selectedPatient.searchIdno) return;
        bdjrnaeyeoDetailData();
        logData();
    }, [selectedPatient]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const handlePatientSelect = (patientInfo) => {
        setSelectedPatient(patientInfo);
    };

    const head1 = ['의료기관명', '기관코드', '지역', '종별', '의무기록번호', '중증도분류선별번호', '성명', '나이/성별', '주소지', '보험유형', '내원일자', '내원시간', '발병일자(*)', '발병시간(*)', '질병여부(*)', '의도성여부(*)', '손상기전(*)', '교통사고손상당사자', '안전벨트', '아동용좌석', '전면에어백', '측면에어백', '헬멧', '무릎및관절보호대', '기타(구명조끼 등)', '전혀착용안함', '비해당', '미상', '주진료과(*)', '내원경로(*)', '전원보낸의료기관종류', '전원보낸의료기관코드', '전원보낼의료기관종류', '전원보낼의료기관코드', '내원수단(*)', '구급활동일지', '주증상(*)', '응급증상 해당여부', '기타증상', '진료결과(*)', '진료결과기타사유', '환자내원시반응(*)', '수축기혈압', '이완기혈압', '분당맥박수', '분당호흡수', '체온', '내원 시 산소포화도', '중증도분류과정(최초)', '중증도분류결과(최초)', '중증도분류일자(최초)', '중증도분류시간(최초)', '중증도 분류자의 직종', '최초 분류자의 면허 또는 자격번호', '중증도분류과정(변경)', '중증도분류결과(변경)', '퇴실시 최종진료구역', '주된진료를 받은 응급의료센터', '전문의 진료여부', '전문의 진료일자', '전문의 진료시간', '격리구역 병상번호', '입원경로', '진료의사 면허번호', '퇴실일자(*)', '퇴실시간(*)', '퇴실진단(*)', '퇴실진단(영문명)', '입원일자', '입원시간', '입원후결과(퇴원형태)', '퇴원일자', '퇴원시간', '퇴원진단', '퇴원진단(영문명)', '전송일자', '상태'];
    const head_column1 = ['EMOGDESC', 'PTMIEMCD', 'EMOGLOCA', 'EMOGGRDC2', 'PTMIIDNO', 'PTMIKTID', 'PTMINAME', 'PTMISEXX', 'PTMIZIPC', 'PTMIIUKD', 'PTMIINDT', 'PTMIINTM', 'PTMIAKDT', 'PTMIAKTM', 'PTMIDGKD', 'PTMIARCF', 'PTMIARCS', 'PTMITAIP', 'PTMITSBT', 'PTMITSCS', 'PTMITSFA', 'PTMITSSA', 'PTMITSHM', 'PTMITSPT', 'PTMIETCT', 'PTMITSNO', 'PTMITSUR', 'PTMITSUK', 'PTMIDEPT', 'PTMIINRT', 'PTMIINTP', 'PTMIINCD', 'PTMIDCTP', 'PTMIDCCD', 'PTMIINMN', 'PTMIREID', 'SYPTCHCO', 'PTMIEMSY', 'PTMIETSY', 'PTMIEMRT', 'PTMIETTX', 'PTMIRESP', 'PTMIHIBP', 'PTMILOBP', 'PTMIPULS', 'PTMIBRTH', 'PTMIBDHT', 'PTMIVOXS', 'PTMIKPR1', 'PTMIKTS1', 'PTMIKTDT', 'PTMIKTTM', 'PTMIKJOB', 'PTMIKIDN', 'PTMIKPR2', 'PTMIKTS2', 'PTMIAREA', 'PTMIMDCD', 'PTMISDCD', 'SDMDSDDT', 'SDMDSDTM', 'PTMIBENO', 'PTMIHSRT', 'PTMIDRLC', 'PTMIOTDT', 'PTMIOTTM', 'DGOTDESC', 'DGOTNAME', 'PTMIHSDT', 'PTMIHSTM', 'PTMIDCRT', 'PTMIDCDT', 'PTMIDCTM', 'DGDCDESC', 'DGDCNAME', 'PTMIWKDT', 'PTMISTAT'];
    const apiCall = '/ptmiapi/jinryo/bdjrnaeyeokdetaillistAsearch.do';
    const apiCntCall = '/ptmiapi/jinryo/bdjrnaeyeokdetaillistAsearchCnt.do';
    const percent1 = ['5%', '13%', '13%', '6%', '14%'];

    const searchParamsAdditional1 = {
        searchType: 'List3',
        searchCheck1: 'New'
    };

    const head2 = ['의료기관명', '등록번호', '전송일자', '전송시간'];
    const head_column2 = ['EMOGNAME', 'PTMIIDNO', 'PTMICRDT', 'PTMICRTM'];
    const percent2 = ['35%', '18%', '18%', '18%'];

    const { isModalOpen, isDown, updateParams, openConfModal, closeModal, handleUpdateInputChange, setIsDown } = useExcelDownloadHook();

    const path = decodeURIComponent(useLocation().pathname);

    useEffect(() => {
        setSearchParams(prev => ({
            ...prev,
            searchGubunS: '*'
        }));
    }, [searchParams.searchGubun]);

    const patientOnly = usePatientOnly();

    useEffect(() => {
        if (patientOnly) {
            setIsListToggle(false);
        }
    }, [patientOnly]);

    return (
        <div className='whole_container'>
            <ExcelDownloadReason_layer
                isModalOpen={isModalOpen}
                closeModal={closeModal}
                updateParams={updateParams}
                handleUpdateInputChange={handleUpdateInputChange}
                searchParams={searchParams}
                route={path}
                excelFileName={`환자상세내역_${desc}.xlsx`}
                setIsDown={setIsDown}
            />
            {isWholeLoading ? <WholeLoading /> : ''}
            <div className={`new search_log_container ${isDetailToggle ? 'search_log_detail_open' : 'search_log_detail_close'} ${isListToggle && 'side_close_list'}`}>
                <Main>
                    <div className='flex flex-col h-full overflow-auto pr-1'>
                        <SelectBox
                            searchParams={searchParams}
                            handleInputChange={handleInputChange}
                            flag={true}
                            setDesc={setDesc}
                        />
                        <div className={`flex gap-5 flex-grow min-h-0 ${patientOnly ? 'flex-row' : 'flex-col'}`}>
                            <PtmiDataGrid
                                dataHead={head1}
                                dataColumn={head_column1}
                                apiCall={apiCall}
                                apiCntCall={apiCntCall}
                                searchParams={searchParams}
                                searchParamsAdditional={searchParamsAdditional1}
                                onPatientSelect={handlePatientSelect}
                                percent={percent1}
                                setIsWholeLoading={setIsWholeLoading}
                                desc={desc}
                                openConfModal={openConfModal}
                                isDown={isDown}
                                setIsListToggle={setIsListToggle}
                            />
                            <hr className={patientOnly ? 'hp-90 border-l mt-6' : ''} />
                            <LogDataGrid
                                dataHead={head2}
                                dataColumn={head_column2}
                                dataList={data2}
                                percent={percent2}
                            />
                        </div>
                    </div>
                </Main>
            </div>
            <div className='flex flex-col my-auto gap-2'>
                {!isListToggle &&
                    <button className={`detail_toggle_btn_box h_icon_box tooltip_box relative ${!data2.length ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => data2.length ? setIsDetailToggle(!isDetailToggle) : ''}>
                        <div className='icon'>{toggleIcon}</div>
                        <div className='hover_icon'>{!data2.length ? toggleIcon : hoverToggleIcon}</div>
                        <span className={`text-center tooltip bg_st_dark ${(!isDetailToggle && patientOnly) && 'detail_position'}`}>{patientOnly ? (isDetailToggle ? '리스트 보기' : <>대상환자를 선택하시면<br/>상세 정보를 확인할 수 있습니다.</>) : (isDetailToggle ? '리스트 함께 보기' : '대상환자정보 넓게 보기')}</span>
                    </button>
                }
                {(!patientOnly && !isDetailToggle) &&
                    <button className={`detail_toggle_btn_box h_icon_box tooltip_box relative ${!data2.length ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => data2.length ? setIsListToggle(!isListToggle) : ''}>
                        <div className='icon'>{listToggleIcon}</div>
                        <div className='hover_icon'>{!data2.length ? listToggleIcon : hoverListToggleIcon}</div>
                        <span className={`text-center tooltip bg_tr_dark ${isListToggle && 'list_position'} ${!data2.length && 'detail_position'}`}>{data2.length ? (isListToggle ? '대상환자정보 함께 보기' : '리스트 넓게 보기') : <>대상환자를 선택하시면<br/>상세 정보를 확인할 수 있습니다.</>}</span>
                    </button>
                }
            </div>
            <div className={`patient_detail ${isDetailToggle ? 'side_open_detail' : 'side_close_detail'} ${isListToggle && 'side_open_list border-none'}`}>
                <JrNaeYeokDetail
                    dataList={data}
                    isDetailToggle={isDetailToggle}
                />
            </div>
        </div>
    )
}

export default BdJrNaeyeokDetailListANew;